<footer>
  <p class="mb-4">Youcef Developer &copy; 2022</p>
  <p>Technologies</p>
  <span class="badge">svelte</span>
  <span class="badge">javascript</span>
  <span class="badge">html/css</span>
  <span class="badge">netlify</span>
</footer>

<style>
  footer {
    text-align: center;
    font-weight: 300;
    font-size: 14px;
    padding: 12px 1px 40px 1px;
    margin-top: 100px;
  }
  .badge {
    background-color: #00afb9;
    color: #fff;
    font-size: 0.7em;
    margin: 2px 0px;
    padding: 0.2rem 0.7rem 0.25rem 0.7rem;
    border-radius: 10px;
  }
  .mb-4 {
    margin-bottom: 25px;
  }
</style>
